import * as React from 'react';
import { useCollapsibleContext } from '@sdk/components/Collapsible/Collapsible';

import { GroupButton } from './conversationMembers.styles';

type Props = {
  children: React.ReactNode;
};

export const GroupHeader = ({ children }: Props) => {
  const { isActive, toggle } = useCollapsibleContext();

  return (
    <GroupButton isActive={isActive} onClick={toggle}>
      {children}
    </GroupButton>
  );
};
